import { render, staticRenderFns } from "./SynonymsPreview.vue?vue&type=template&id=13a30ad8&lang=pug&"
import script from "./SynonymsPreview.vue?vue&type=script&lang=js&"
export * from "./SynonymsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports